import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { FAQ } from '../components/FAQ';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { DemoBanner } from '../components/DemoBanner';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-331">
      <Header data-id="element-332" />
      <main data-id="element-333">
        <Hero data-id="element-334" />
        <About data-id="element-335" />
        <Services data-id="element-336" />
        <FAQ data-id="element-337" />
        <WhyChooseUs data-id="element-338" />
        <Contact data-id="element-339" />
      </main>
      <Footer data-id="element-340" />
      <DemoBanner data-id="element-341" />
    </div>;
}